import { SVGPropsIcon } from 'src/types';

export const NavbarDepositIcon = (props: SVGPropsIcon) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none">
    <mask
      id="mask0_15121_15285"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16">
      <path d="M0.5 0.500001H15.5V15.5H0.5V0.500001Z" fill="white" />
    </mask>
    <g mask="url(#mask0_15121_15285)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.28906 8.87891C9.28906 10.0924 10.2728 11.0762 11.4863 11.0762H15.5V6.68164H11.4863C10.2728 6.68164 9.28906 7.66539 9.28906 8.87891ZM11.4863 10.1973C10.7582 10.1973 10.168 9.60701 10.168 8.87891C10.168 8.1508 10.7582 7.56055 11.4863 7.56055H14.6211V10.1973H11.4863Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9258 8.43945H11.0469V9.31836H11.9258V8.43945Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5625 7.56055V4.04492H1.81836V4.92383H13.6836V7.56055H14.5625Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 3.60547C0.5 4.3336 1.09028 4.92383 1.81836 4.92383H12.8047V2.28711H1.81836C1.09027 2.28711 0.5 2.87738 0.5 3.60547ZM1.81836 4.04492C1.57566 4.04492 1.37891 3.84818 1.37891 3.60547C1.37891 3.36278 1.57567 3.16602 1.81836 3.16602H11.9258V4.04492H1.81836Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 11.5156C0.5 12.7291 1.48375 13.7129 2.69727 13.7129H14.5625V10.1973H13.6836V12.834H2.69727C1.96916 12.834 1.37891 12.2437 1.37891 11.5156V3.60547H0.5V11.5156Z"
        fill="white"
      />
    </g>
  </svg>
);
